import React from "react";
import { useApi } from "../hooks/useApi";

export default function MarketNarrative() {
  const { data } = useApi("/intelligence", 30000);

  const text      = data?.regime_text || "⚪ Connecting to Brain...";
  const poly      = data?.poly_probs  || {};
  const calBlocked = data?.cal_blocked;
  const calEvent   = data?.cal_event;

  // Derive banner colour from text
  const isRed    = text.startsWith("🔴");
  const isYellow = text.startsWith("🟡");
  const isGreen  = text.startsWith("🟢");

  const bg     = isRed ? "#1a0a0a" : isYellow ? "#1a1400" : isGreen ? "#071a0e" : "#0d1224";
  const border = isRed ? "#7f1d1d" : isYellow ? "#78350f" : isGreen ? "#14532d" : "#1e2a45";
  const color  = isRed ? "#fca5a5" : isYellow ? "#fde68a" : isGreen ? "#86efac" : "#94a3b8";

  return (
    <div style={{ background: bg, border: `1px solid ${border}`, borderRadius: "10px", padding: "12px 18px" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "10px" }}>

        {/* Main narrative */}
        <div style={{ fontSize: "14px", fontWeight: 600, color, flex: 1 }}>{text}</div>

        {/* Polymarket crowd probabilities */}
        <div style={{ display: "flex", gap: "16px", fontSize: "11px", flexShrink: 0 }}>
          {[
            { label: "Recession", val: poly.recession, warn: 0.5 },
            { label: "Rate Hike",  val: poly.rate_hike,  warn: 0.6 },
            { label: "Oil Shock",  val: poly.oil_disruption, warn: 0.4 },
            { label: "Conflict",   val: poly.conflict,   warn: 0.4 },
          ].map(({ label, val, warn }) => {
            const pct = val != null ? Math.round(val * 100) : null;
            const c   = pct == null ? "#475569" : pct >= warn * 100 ? "#f87171" : "#4ade80";
            return (
              <div key={label} style={{ textAlign: "center" }}>
                <div style={{ color: "#475569" }}>{label}</div>
                <div style={{ color: c, fontWeight: 700, fontSize: "13px" }}>
                  {pct != null ? `${pct}%` : "—"}
                </div>
              </div>
            );
          })}
        </div>

        {/* Calendar warning */}
        {calBlocked && (
          <div style={{ background: "#78350f", border: "1px solid #92400e", borderRadius: "6px",
                        padding: "4px 10px", fontSize: "11px", color: "#fde68a" }}>
            ⏰ {calEvent}
          </div>
        )}
      </div>
    </div>
  );
}
